import React, { Component } from 'react'
import { ResponsiveLine } from '@nivo/line'
import { Card } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import * as smsActions from '../../_actions/sms.actions'

const moment = require('moment')

class SmsDashboard extends Component {
    componentDidMount = () => {
        this.props.actions.smsActions.statisticsSms()
    }

    generateStats = data => {
        const stats = []

        const statsCollected = _.map(data, d => {
            return {
                x: moment(d.date).format('D MMM'),
                y: d.total,
                cost: d.cost,
            }
        })

        stats.push({
            id: 'SMS Sent',
            color: 'hsl(123, 70%, 50%)',
            data: statsCollected,
        })
        return stats
    }

    render() {
        const data = this.generateStats(this.props.stats.data)
        return (
            <div className="row">
                <div className="col-sm-12 col-md-12">
                    <div className="panel">
                        <div className="panel-heading">
                            <h2 className="panel-title">Statistics</h2>
                        </div>
                        <div className="panel-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12">
                                        <div className="site-card-border-less-wrapper">
                                            <Card
                                                title="Overview"
                                                bordered={false}
                                            >
                                                <div style={{ height: 400 }}>
                                                    <ResponsiveLine
                                                        data={data}
                                                        margin={{
                                                            top: 50,
                                                            right: 110,
                                                            bottom: 50,
                                                            left: 60,
                                                        }}
                                                        xScale={{
                                                            type: 'point',
                                                        }}
                                                        yScale={{
                                                            type: 'linear',
                                                            min: 0,
                                                            max: 'auto',
                                                            stacked: true,
                                                            reverse: false,
                                                        }}
                                                        axisTop={null}
                                                        axisRight={null}
                                                        axisBottom={{
                                                            orient: 'bottom',
                                                            tickSize: 5,
                                                            tickPadding: 5,
                                                            tickRotation: 0,
                                                            legend:
                                                                'SMS Statistics',
                                                            legendOffset: 36,
                                                            legendPosition:
                                                                'middle',
                                                        }}
                                                        axisLeft={null}
                                                        // axisLeft={{
                                                        //     orient: 'left',
                                                        //     tickSize: 10,
                                                        //     tickPadding: 10,
                                                        //     tickRotation: 0,
                                                        //     legend: 'total',
                                                        //     legendOffset: -40,
                                                        //     legendPosition:
                                                        //         'middle',
                                                        // }}
                                                        colors={{
                                                            scheme: 'nivo',
                                                        }}
                                                        pointSize={5}
                                                        pointColor={{
                                                            theme: 'background',
                                                        }}
                                                        pointBorderWidth={2}
                                                        pointBorderColor={{
                                                            from: 'serieColor',
                                                        }}
                                                        pointLabel="y"
                                                        enableGridY={false}
                                                        enablePointLabel={true}
                                                        pointLabelYOffset={-12}
                                                        useMesh={true}
                                                        legends={[
                                                            {
                                                                anchor:
                                                                    'bottom-right',
                                                                direction:
                                                                    'column',
                                                                justify: false,
                                                                translateX: 100,
                                                                translateY: 0,
                                                                itemsSpacing: 0,
                                                                itemDirection:
                                                                    'left-to-right',
                                                                itemWidth: 80,
                                                                itemHeight: 20,
                                                                itemOpacity: 0.75,
                                                                symbolSize: 12,
                                                                symbolShape:
                                                                    'circle',
                                                                symbolBorderColor:
                                                                    'rgba(0, 0, 0, .5)',
                                                                effects: [
                                                                    {
                                                                        on:
                                                                            'hover',
                                                                        style: {
                                                                            itemBackground:
                                                                                'rgba(0, 0, 0, .03)',
                                                                            itemOpacity: 1,
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        ]}
                                                    />
                                                </div>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return { stats: state.sms }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            smsActions: bindActionCreators(smsActions, dispatch),
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SmsDashboard)
